import { AppointmentForm, Modal } from '@/components'
import { StyledButton } from '@/components/styles'
import { useTranslation } from "react-i18next";

const Trigger = props => {
  const { t } = useTranslation("global");
  return <StyledButton light arrow {...props}>{t('bookAppointment')}</StyledButton>
}

export default function Appointment({ render: TriggerView = Trigger }) {
  return (
    <Modal render={TriggerView} view="appointment">
      <AppointmentForm />
    </Modal>
  )
}
